module.exports = __webpack_public_path__ + "static-portal/img/news12-4.3c0f3c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news12-4.jpg
// module id = PENg
// module chunks = 4